<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Actualizar Documento Cargado
  </h2>
  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      (click)="goBack()"
      class="block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
    >
      Volver
    </button>
  </div>
  <form (ngSubmit)="saveDocumentoCargado()">
    <div class="mb-4">
      <label for="archivo" class="block text-sm font-medium mb-1"
        >Subir Archivo:</label
      >
      <input
        type="file"
        id="archivo"
        (change)="onFileSelected($event)"
        class="border border-gray-300 rounded py-2 px-4 w-full"
        required
      />
      <p *ngIf="errorArchivo" class="text-red-500 text-sm mt-2">
        {{ errorArchivo }}
      </p>
    </div>

    <div class="mb-4">
      <label for="linkArchivo" class="block text-sm font-medium mb-1"
        >Link del Archivo:</label
      >
      <input
        type="url"
        id="linkArchivo"
        [(ngModel)]="linkArchivo"
        name="linkArchivo"
        class="border border-gray-300 rounded py-2 px-4 w-full"
        [readonly]="true"
        placeholder="El enlace generado se mostrará aquí"
        required
      />
    </div>

    <div class="flex justify-end items-center">
      <button
        type="submit"
        [disabled]="!linkArchivo"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Guardar
      </button>
    </div>
  </form>
</div>
